// extracted by mini-css-extract-plugin
export default {"capturedImage":"captured-image-module__capturedImage--RD8_y","frame":"captured-image-module__frame--d9jw2","mirror":"captured-image-module__mirror--BdNjf"};